"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const SvgParcel_vue_1 = __importDefault(require("@common/components/SvgParcel.vue"));
const ClusterEditorReport_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/ClusterEditorReport.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const debounce_1 = require("@common/tsutils/debounce");
let ClusterEditorParcel = class ClusterEditorParcel extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.clusteredIdx = null;
        this.disabled = false;
        this.enabledSamples = [];
        //
        // This two attributes allow to avoid infinite loops
        //
        this.insideChange = false;
        this.outsideChange = false;
    }
    get _uid() {
        return Math.random();
    }
    mounted() {
        this.initDisabled();
    }
    initDisabled() {
        this.enabledSamples = this.parcel.samples.filter(sample => {
            return !this.sampleDisabledFn(sample);
        });
        // Check at least one sample is enabled
        this.disabled = this.enabledSamples.length === 0;
    }
    get bluckClasses() {
        const classes = {};
        // Check if selected
        if (this.clusteredIdx !== null) {
            classes['cluster--' + (this.clusteredIdx + 1)] = true;
        }
        return classes;
    }
    clickNext() {
        if (this.disabled) {
            return;
        }
        if (this.clusteredIdx === null) {
            this.clusteredIdx = 0;
        }
        else if (this.clusteredIdx >= this.clusters.length - 1) {
            this.clusteredIdx = null;
        }
        else {
            this.clusteredIdx++;
        }
        // @ts-ignore
        window.mixpanel.track('Whole Parcel to Cluster');
    }
    onClusterChangeFromOutside() {
        if (this.insideChange) {
            this.insideChange = false;
            return;
        }
        this.outsideChange = true;
        this.onClusterChangeFromOutside2();
    }
    onClusterChangeFromOutside2() {
        // Update the selected idx if needed
        let myIdx;
        for (const sample of this.parcel.samples) {
            const sIdx = this.clusters.getClusterIdx(sample);
            if (myIdx === undefined) {
                myIdx = sIdx;
                continue;
            }
            if (myIdx !== sIdx) {
                myIdx = null;
                break;
            }
        }
        // Ensure type is number or null (but not undefined)
        myIdx = myIdx !== undefined ? myIdx : null;
        // Modify only if change
        if (this.clusteredIdx !== myIdx) {
            this.clusteredIdx = myIdx;
        }
        this.$nextTick(() => { this.outsideChange = false; });
    }
    onChangeClusterIdx() {
        if (this.outsideChange)
            return;
        this.onChangeClusterIdx2();
    }
    onChangeClusterIdx2() {
        this.insideChange = true;
        this.enabledSamples.forEach(sample => {
            this.clusters.addSample(sample, this.clusteredIdx);
        });
    }
    ;
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorParcel.prototype, "parcel", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorParcel.prototype, "clusters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorParcel.prototype, "focus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorParcel.prototype, "sampleDisabledFn", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('clusters', { deep: true })
], ClusterEditorParcel.prototype, "onClusterChangeFromOutside", null);
__decorate([
    (0, debounce_1.PerInstanceDebounce)(100)
], ClusterEditorParcel.prototype, "onClusterChangeFromOutside2", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('clusteredIdx')
], ClusterEditorParcel.prototype, "onChangeClusterIdx", null);
__decorate([
    (0, debounce_1.PerInstanceDebounce)(150)
], ClusterEditorParcel.prototype, "onChangeClusterIdx2", null);
ClusterEditorParcel = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            SvgParcel: SvgParcel_vue_1.default,
            ClusterEditorReport: ClusterEditorReport_vue_1.default,
            CornerRightDown: lucide_vue_next_1.CornerRightDown
        }
    })
], ClusterEditorParcel);
exports.default = ClusterEditorParcel;
